import { Component, HostBinding } from '@angular/core';

import version from '../../../../../package.json';

import {
  BrandingService,
  BrandProfile,
} from 'src/app/shared/branding/branding.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly brand: BrandProfile;

  constructor(branding: BrandingService) {
    this.brand = branding.brand;
  }

  @HostBinding('class') classes = 'main-footer';
  get currentYear() {
    return new Date().getFullYear();
  }

  get currentAppVersion() {
    return version.version;
  }
}
